<template>
  <div class="container-fluid m-section">
    <div class="m-section__header">
      <div class="row justify-content-center align-items-center">
        <div class="col-9">
          <div class="m-section__headline">
            Métricas operativas
            <span
              class="m-section__date ml-2"
              v-if="getStatistics.hasOwnProperty('labelDate')"
            >
              Del {{ getStatistics.labelDate }}
            </span>
            <span
              class="m-section__date ml-2"
              v-if="getStatistics.hasOwnProperty('week')"
            >
              <strong>|</strong>&nbsp; {{ getStatistics.week }}
            </span>
          </div>
        </div>
        <div class="col-3">
          <button class="btn"  :class="statusCatering === 'Periodo aprobado' ? 'btn-outline-success' : 'btn-outline-danger'"  style="pointer-events: none;">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="statusCatering === 'Periodo aprobado'">
              <path d="M12.9999 4.24953L5.99994 12.2495L2.99994 9.24953" stroke="#1AAE6F" stroke-width="2.0625" stroke-miterlimit="10" stroke-linecap="square"/>
            </svg>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
              <path d="M11.8907 0.518799L6.9405 5.4678L1.9915 0.518799L0.341834 2.16847L5.29083 7.11747L0.341834 12.0665L1.9915 13.7161L6.9405 8.76713L11.8907 13.7161L13.5403 12.0665L8.59133 7.11747L13.5403 2.16847L11.8907 0.518799Z" fill="#F80031"/>
            </svg>
            <span v-if = "statusCatering === 'Periodo aprobado'" style="color: #1AAE6F" >{{ statusCatering }}</span>
            <span v-else style="color: #F80031" >{{ statusCatering }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-if="data">
      <div class="row">
        <div class="col">
          <NewCardPeriod
            :data="data.califications"
            :name="'ratio'"
            :title="'Calificación de pedidos'"
            @addColor="addColor"
            :action="true"
            :url="'/foodcourt/feedback'"
          />
        </div>
        <div class="col">
          <NewCardPeriod
            :data="data.cancellationRate"
            :name="'cancelations'"
            :title="'Tasa de cancelaciones'"
            @addColor="addColor"
          />
        </div>

        <div class="col">
          <NewCardPeriod
            :data="data.availability"
            :name="'availability'"
            :title="'Disponibilidad'"
            @addColor="addColor"
          />
        </div>

        <div class="col">
          <NewCardPeriod
            :data="data.avgTardies"
            :name="'tardies'"
            :title="'Tardanzas'"
            @addColor="addColor"
          />
        </div>

      </div>
    </div>

    <CustomModal :is-modal="modals" @closeModal="modals = false" :closeOuth="true" :width="'xlg'">
      <h5 class="modal-title">Calificaciones:</h5>
      <div class="table-responsive mt-4">
        <el-table :data="itemsTable.items" row-key="name" header-row-class-name="thead-light">
          <el-table-column v-for="column in itemsTable.columns" :key="column.label" v-bind="column"></el-table-column>
        </el-table>
      </div>
    </CustomModal>
  </div>
</template>

<script>
import NewCardPeriod from "@/components/Metrics/NewCardPeriod.vue";
import CardPeriod from "@/components/Metrics/CardPeriod.vue";
import LinkPdf from "@/components/Metrics/LinkPdf.vue";
import {mapActions, mapGetters} from "vuex";
import BackofficeApi from "@/gateways/backoffice-api";
import moment from "moment/moment";
import CustomModal from "@/components/CustomModal.vue";
import BaseTable from "@/components/BaseTable.vue";
import {Table, TableColumn} from "element-ui";


export default {
  data() {
    return {
      data: [],
      qualifications: [],
      color: [],
      modals: false,
      itemsTable: {
        items: [],
        columns: [
          {
            prop: 'delivery_date',
            label: 'Fecha',
            minWidth: 200,
            sortable: true,
          },
          {
            prop: 'name',
            label: 'Cliente',
            minWidth: 150,
            sortable: true,
          },
          {
            prop: 'restaurant_qualification',
            label: 'Calificacion',
            minWidth: 200,
            sortable: true,
          },
          {
            prop: 'comment',
            label: 'Comentario',
            minWidth: 100,
            sortable: true,
          },
        ],
      }
    }
  },
  components: {
    BaseTable,
    CustomModal,
    LinkPdf,
    CardPeriod,
    NewCardPeriod,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    await this.GET_METRIC();
    await this.getData();
  },
  computed: {
    ...mapGetters("metrics", ["getStatistics"]),
    host() {
      return process.env.VUE_APP_API_BACKOFFICE_URL.replace("/api/v1/", "");
    },
    statusCatering() {
      let verdes = 0;
      let amarillos = 0;
      let rojos = 0;

      for (const color of this.color) {
        if (color === "green") {
          verdes++;
        } else if (color === "orange") {
          amarillos++;
        } else if (color === "red") {
          rojos++;
        }
      }
      if (amarillos > 2 || rojos >= 1) {
        return "Periodo no aprobado - en periodo de prueba ";
      }else{
        return "Periodo aprobado";
      }
    }
  },
  methods: {
    ...mapActions("metrics", ["GET_METRIC", "GET_PROGRESS"]),
    async getData() {
      const labelDate = this.getStatistics.labelDate;
      const dateStr = labelDate.split(" al ");
      const start = moment(dateStr[0].trim(), "DD/MM/YYYY").format('YYYY-MM-DD');
      const end = moment(dateStr[1].trim(), "DD/MM/YYYY").format('YYYY-MM-DD');
      let params = {
        range: [start, end],
        catering_id: JSON.parse(localStorage.getItem("userData")).catering_id,
      }
      const path = this.host + "/api/v3/metric/foodcourt";
      const response = await BackofficeApi.get(path, {params});
      this.data = response.data.detail.data[0]
    },
    addColor(event) {
      this.color.push(event.color)
    }
  }
}
</script>

<style scoped>

</style>
